import { FC, useState } from 'react';
import { WidgetCell, WidgetProps } from '../WidgetCell';
import { FormattedMessage, useIntl } from 'react-intl';
import { Stack, Typography } from '@mui/material';
import { Avatar } from '../../../../../components/Avatar';
import { useDrawerContext } from '../../../../../drawer/DrawerContext';
import { CONTROL_CYCLE_OPTIONS } from './consts';
import { RelativeTime } from '../../../../../journey/RelativeTime';
import { getFragmentData, graphql } from '../../../../../gql';
import slugify from 'slugify';
import { widgetDefinitions } from '../widgetDefinitions';

const memberFragment = graphql(`
	fragment OwnerCell_Member on Member {
		id
		avatar {
			url(width: 40, height: 40)
		}
		name
		jobTitle
	}
`);

export const OwnerCell: FC<WidgetProps> = ({ widget: { owner: ownerData, controlCycle }, activityId, activityName }) => {
	const [editMode, setEditMode] = useState(false);
	const intl = useIntl();
	const { setDrawerWithoutPrevParams } = useDrawerContext();

	const owner = getFragmentData(memberFragment, ownerData);

	return (
		<WidgetCell
			showEditOnHover
			data-activity-widget-name={slugify(activityName, { lower: true })}
			data-activity-widget-type={widgetDefinitions.owner.type}
			editMode={editMode}
			tooltipText={intl.formatMessage({ id: 'journey.detail.widget.edit' })}
			handleEditAction={() => {
				setDrawerWithoutPrevParams('editOwner', { activityId }, () => setEditMode(false));
				setEditMode(true);
			}}
		>
			{owner && (
				<Stack direction={'row'} gap={1.5}>
					<Avatar variant={'circular'} sx={{ width: 40, height: 40 }} src={owner.avatar?.url ?? ''} alt={owner.name} />
					<Stack direction={'column'} gap={1.5}>
						<Stack>
							<Typography variant={'h5'} fontWeight={700}>
								{owner.name}
							</Typography>
							<Typography>{owner.jobTitle ?? <>&nbsp;</>}</Typography>
						</Stack>
						{Boolean(controlCycle?.history.length) && Boolean(controlCycle?.days) && (
							<Stack direction={'column'} gap={1.5}>
								{controlCycle?.history[0]?.at && (
									<Stack direction={'column'}>
										<Typography variant={'subtitle1'}>
											<FormattedMessage id={'widget.owner.last-check'} />
										</Typography>
										<Typography>
											<RelativeTime date={controlCycle.history[0].at} />
										</Typography>
									</Stack>
								)}
								<Stack direction={'column'}>
									<Typography variant={'subtitle1'}>
										<FormattedMessage id={'widget.owner.check-interval'} />
									</Typography>
									<Typography>{CONTROL_CYCLE_OPTIONS[controlCycle?.days as keyof typeof CONTROL_CYCLE_OPTIONS]}</Typography>
								</Stack>
							</Stack>
						)}
					</Stack>
				</Stack>
			)}
		</WidgetCell>
	);
};
